import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Form, FormActions, FormFields, FormTextField, useNotifications } from "sprint-common-web";

import { useNotesState } from "../hooks/state/useNotesState";
import { useNotesActions } from "../hooks/useNotesActions";

interface NotesFormInputs {
    note: string;
}

export const NotesForm: React.FC = () => {
    const { success, error } = useNotifications();
    const { createNote } = useNotesActions();
    const { setNotes, notes, subjectId, subjectType, disabled } = useNotesState();
    const { handleSubmit, reset, watch, control, errors } = useForm<NotesFormInputs>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleCreateNote = () => {
        const { note } = watch();

        setIsLoading(true);
        createNote(subjectId, note, subjectType)
            .then((createdNote) => {
                setNotes([createdNote, ...notes]);
                success("Note created successfully");
            })
            .catch((e) => {
                console.error(e);
                error("Failed to create note");
            })
            .finally(() => {
                handleClearForm();
                setIsLoading(false);
            });
    };

    const handleClearForm = () => {
        reset();
    };

    return (
        <Form onSubmit={handleSubmit(handleCreateNote)} style={{ marginTop: 40 }}>
            <FormFields>
                <FormTextField
                    label="Note"
                    placeholder="Add a note ..."
                    name="note"
                    control={control}
                    errors={errors}
                    rules={{
                        maxLength: { value: 500, message: "Note must not be longer than 500 characters" }
                    }}
                    disabled={disabled}
                />
            </FormFields>
            <FormActions
                onCancel={handleClearForm}
                isLoading={isLoading}
                submitDisabled={disabled}
                testId="submit-note-button"
            />
        </Form>
    );
};
